import React from 'react';
import logoFb from '../assets/logofb.svg';
import logoInsta from '../assets/logoinsta.svg';
import logoGmb from '../assets/logogmb.svg';
import logoIn from '../assets/logoin.svg';

export const socialMediaCellRenderer = (params: any): JSX.Element => {
    let insta = params.data.insta;
    let fb = params.data.fb;
    let gmb = params.data.gmb;
    let linkedin = params.data.linkedin;
    if (params.data.social && params.data.social.length > 0) {
        insta = params.data.social.includes('instagram') ? 'instagram' : '';
        fb = params.data.social.includes('facebook') ? 'facebook' : '';
        gmb = params.data.social.includes('googleMyBusiness') ? 'googleMyBusiness' : '';
        linkedin = params.data.social.includes('linkedin') ? 'linkedin' : '';
    }
    let isActive = (network: string) => (network ? 'filter-none' : 'grayscale');

    return (
        <>
            <div className={'flex items-center justify-center h-full w-full gap-3'}>
                <img src={logoFb} alt="Facebook" className={`w-[20px] h-[20px] ${isActive(fb)}`} />
                <img
                    src={logoInsta}
                    alt="Instagram"
                    className={`w-[20px] h-[20px] ${isActive(insta)}`}
                />
                <img
                    src={logoGmb}
                    alt="Google My Business"
                    className={`w-[20px] h-[20px] ${isActive(gmb)}`}
                />
                <img
                    src={logoIn}
                    alt="LinkedIn"
                    className={`w-[20px] h-[20px] ${isActive(linkedin)}`}
                />
            </div>
        </>
    );
};
